import React, { useState } from 'react';
const privacyContent = {
  title: 'Política de Privacidad',
  sections: [{
    heading: '1. Responsable del Tratamiento',
    text: 'El responsable del tratamiento de tus datos personales es El Método Fénix 45+. Nos comprometemos a proteger tu privacidad y a tratar tus datos de acuerdo con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica de Protección de Datos (LOPD).'
  }, {
    heading: '2. Datos que Recopilamos',
    text: 'Recopilamos únicamente los datos que nos proporcionas voluntariamente al registrarte o realizar una compra: nombre, dirección de correo electrónico y datos de pago. No recopilamos datos sensibles ni compartimos tu información con terceros sin tu consentimiento.'
  }, {
    heading: '3. Finalidad del Tratamiento',
    text: 'Tus datos serán utilizados para: gestionar tu acceso al programa, enviarte comunicaciones relacionadas con el servicio contratado, y, solo si nos das tu consentimiento expreso, enviarte información comercial sobre productos o servicios similares.'
  }, {
    heading: '4. Derechos del Usuario',
    text: 'Tienes derecho a acceder, rectificar, suprimir, limitar el tratamiento, portar y oponerte al tratamiento de tus datos personales. Para ejercer estos derechos, puedes escribirnos a nuestra dirección de correo electrónico indicada en la web.'
  }, {
    heading: '5. Cookies',
    text: 'Este sitio web utiliza cookies propias y de terceros para mejorar la experiencia de navegación y analizar el uso del sitio. Puedes configurar tu navegador para rechazar las cookies, aunque esto podría afectar a la funcionalidad del sitio.'
  }, {
    heading: '6. Conservación de Datos',
    text: 'Tus datos se conservarán mientras dure la relación contractual y durante el tiempo necesario para cumplir con las obligaciones legales aplicables.'
  }]
};
const termsContent = {
  title: 'Aviso Legal',
  sections: [{
    heading: '1. Información General',
    text: 'Este sitio web es propiedad de El Método Fénix 45+. El acceso y uso de este sitio web implica la aceptación plena y sin reservas de todas las condiciones incluidas en este Aviso Legal.'
  }, {
    heading: '2. Propiedad Intelectual',
    text: 'Todos los contenidos de este sitio web, incluyendo textos, imágenes, diseño gráfico, logotipos, iconos, software y cualquier otro material, están protegidos por las leyes de propiedad intelectual. Queda prohibida su reproducción, distribución o transformación sin autorización expresa.'
  }, {
    heading: '3. Condiciones de Compra',
    text: 'Al adquirir el programa, aceptas las condiciones de venta vigentes en el momento de la compra. El precio indicado incluye los impuestos aplicables. El acceso al programa se otorga tras la confirmación del pago.'
  }, {
    heading: '4. Garantía de Devolución',
    text: 'Ofrecemos una garantía de devolución de 30 días desde la fecha de compra. Si no estás satisfecha con el programa, puedes solicitar el reembolso completo sin necesidad de justificación dentro de dicho plazo.'
  }, {
    heading: '5. Limitación de Responsabilidad',
    text: 'Los resultados del programa pueden variar según cada persona. No garantizamos ingresos específicos ni resultados concretos. El contenido del programa es educativo y orientativo. La responsabilidad de aplicar lo aprendido recae en el usuario.'
  }, {
    heading: '6. Legislación Aplicable',
    text: 'Este Aviso Legal se rige por la legislación española. Para cualquier controversia que pudiera derivarse del acceso o uso de este sitio web, las partes se someten a los juzgados y tribunales del domicilio del usuario.'
  }]
};
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const modalContent = activeModal === 'privacy' ? privacyContent : activeModal === 'terms' ? termsContent : null;
  return <>
      <footer className="py-8" style={{
      backgroundColor: '#0A1929',
      borderTop: '1px solid rgba(201,168,76,0.2)'
    }} data-id="element-54">
        <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-55">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-56">
            <p className="font-body text-sm" style={{
            color: '#4A6A8A'
          }} data-id="element-57">
              © 2025 El Método Fénix 45+ · Todos los derechos reservados
            </p>
            <div className="flex gap-6" data-id="element-58">
              <button onClick={() => setActiveModal('privacy')} className="font-body text-xs transition-colors duration-200 hover:text-yellow-400 cursor-pointer bg-transparent border-none" style={{
              color: '#4A6A8A'
            }} data-id="element-59">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="font-body text-xs transition-colors duration-200 hover:text-yellow-400 cursor-pointer bg-transparent border-none" style={{
              color: '#4A6A8A'
            }} data-id="element-60">
                Aviso Legal
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {activeModal && modalContent && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-61">
          {/* Backdrop */}
          <div className="absolute inset-0" style={{
        backgroundColor: 'rgba(10, 25, 41, 0.85)',
        backdropFilter: 'blur(6px)'
      }} data-id="element-62" />

          {/* Modal content */}
          <div className="relative w-full max-w-2xl max-h-[85vh] rounded-2xl overflow-hidden flex flex-col" style={{
        backgroundColor: '#0F2540',
        border: '1px solid rgba(201,168,76,0.3)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.5)'
      }} onClick={e => e.stopPropagation()} data-id="element-63">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 flex-shrink-0" style={{
          borderBottom: '1px solid rgba(201,168,76,0.2)'
        }} data-id="element-64">
              <h2 className="font-heading font-bold text-xl" style={{
            color: '#C9A84C'
          }} data-id="element-65">
                {modalContent.title}
              </h2>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full transition-colors duration-200 hover:bg-white/10" style={{
            color: '#A8C0D8'
          }} data-id="element-66">
                ✕
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 py-6 flex-1 space-y-6" data-id="element-67">
              {modalContent.sections.map((section, i) => <div key={i} data-id="element-68">
                  <h3 className="font-heading font-bold text-base mb-2" style={{
              color: '#E2C97E'
            }} data-id="element-69">
                    {section.heading}
                  </h3>
                  <p className="font-body text-sm leading-relaxed" style={{
              color: '#A8C0D8'
            }} data-id="element-70">
                    {section.text}
                  </p>
                </div>)}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 flex-shrink-0 text-center" style={{
          borderTop: '1px solid rgba(201,168,76,0.2)'
        }} data-id="element-71">
              <button onClick={() => setActiveModal(null)} className="px-6 py-2 rounded-lg font-body font-bold text-sm transition-all duration-200 hover:brightness-110" style={{
            backgroundColor: '#C9A84C',
            color: '#0F2540'
          }} data-id="element-72">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}